<template>
    <div class="app-container">

        <el-row class="navigation">
            <el-col align="left">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '' }">知识产权综合服务</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/zscqzhfw/zscqcs' }">知识产权超市</el-breadcrumb-item>
                    <el-breadcrumb-item>专利详情</el-breadcrumb-item>
                </el-breadcrumb>
                <!--
                <span>当前位置: &nbsp;&nbsp;</span>
                <span>知识产权综合服务 </span>
                <span>&nbsp; &gt; &nbsp;</span>
                <el-link :underline="false" @click="toPage('/main/zscqzhfw/zscqcs')"> 知识产权超市 </el-link>
                <span>&nbsp; &gt; &nbsp;</span>
                <el-link :underline="false" @click="refresh" class="router"> 专利详情</el-link>
                -->
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="18">
                <el-card>
                    <el-row>
                        <el-col :span="6" class="left-img">
                            <img src="@/assets/images/fxxfdw/noComplaints.png"/>
                        </el-col>
                        <el-col :span="18">
                            <el-row>
                                <el-col :span="20">
                                    <el-row class="detail-title">
                                        {{detail.patentName}}
                                    </el-row>
                                    <el-row class="detail-row">
                                        <el-tag type="success" effect="dark" v-if="detail.patentType=='syxx'">{{dictFormatType(detail.patentType)}}</el-tag>
                                        <el-tag type="" effect="dark" v-else-if="detail.patentType=='fm'">{{dictFormatType(detail.patentType)}}</el-tag>
                                        <el-tag type="warning" effect="dark" v-else-if="detail.patentType=='wgsj'">{{dictFormatType(detail.patentType)}}</el-tag>
                                        <el-tag type="danger" effect="dark" v-else>{{dictFormatType(detail.patentType)}}</el-tag>

                                        <el-tag type="" effect="plain" >专利权维持</el-tag>

                                        <el-tag type="success" effect="plain" v-if="detail.patentStatus=='yx'">{{dictFormatPatentStatus(detail.patentStatus)}}</el-tag>
<!--                                        <el-tag type="warning" effect="plain" v-else-if="detail.patentStatus=='scz'">{{dictFormatPatentStatus(detail.patentStatus)}}</el-tag>-->
                                        <el-tag type="warning" effect="plain" v-else>{{dictFormatType(detail.patentStatus)}}</el-tag>

                                        <el-tag v-for="field in fields">{{dictFormatField(field)}}</el-tag>
                                    </el-row>
                                </el-col>

                                <el-col :span="4">
                                    {{browseCount}}人看过
                                </el-col>
                            </el-row>

                            <el-row class="detail-row">
                                专利号：{{detail.patentNo}}
                            </el-row>
                            <el-row class="detail-row">
                                <el-col :span="12">
                                    申请日期：{{detail.applyDate}}
                                </el-col>
                                <el-col :span="12">
                                    发布日期：{{detail.fbDate}}
                                </el-col>
                            </el-row>
                            <el-row class="detail-row">
                                <el-col :span="24">
                                    发明（设计）人：{{detail.patentInventor}}
                                </el-col>
                            </el-row>
                            <el-row class="detail-row">
                                <el-col :span="24">
                                    申请（专利）人：{{detail.patentApplicant}}
                                </el-col>
                            </el-row>
                            <el-divider></el-divider>
                            <el-row class="detail-row2">
                                <el-col :span="12" >
                                    参考价格：
                                    <span class="font-orange fontsize15" v-if="detail.patentPrice==null">询价</span>
                                    <span class="font-orange fontsize15" v-else>{{detail.patentPrice}}</span>
                                </el-col>
                                <el-col :span="12">
                                    专利方联系方式：
                                    <span v-if="!isLoginState"><el-tag>登录后查看</el-tag></span>
                                    <span v-if="isLoginState" class="font-orange fontsize15">{{detail.phone}}</span>
                                </el-col>
                            </el-row>

                        </el-col>
                    </el-row>
                    <el-row style="display: flex;">
                        <div style="padding:5px 15px 5px 50px;">
                            <img src="@/assets/images/zscqcs/wxts.png" style="height: 40px">
                        </div>
                        <div class="tips">
                            <span style="color:#E6A23C;">温馨提示：</span>
                            <span class="tips-2">如您选择自行与转让方对接，请自行鉴别真伪，以防被骗。否则由此产生的所有风险均由您独自承担。</span>
                        </div>
                    </el-row>
                </el-card>

                <el-card class="box-card">
                    <div slot="header" class="card-header">
                        <div class="card-header-left">
                            <img src="@/assets/images/cjgk/bzhy.png" />
                        </div>
                        <div class="card-header-right">
                            <span>专利摘要</span>
                        </div>
                    </div>
                    <div style="min-height: 500px;line-height: 25px;text-indent: 28px;">
                        {{detail.patentAbstract}}
                    </div>
                </el-card>
            </el-col>
            <el-col :span="6" class="page-right">
                <el-card style="margin-bottom: 1.25rem;background:-webkit-gradient(linear, 0 0, 0 100%, from(#d8e6f7), to(#FFFFFF));">
                    <div style="display: flex;">
                        <div class="zscqzx-img">
                            <img src="@/assets/images/cjgk/cjjg.png">
                        </div>
                        <div>
                            <el-row class="zscqzx">
                                知识产权中心
                            </el-row>
                            <el-row class="font-orange zscqzx">
                                5803699
                            </el-row>
                        </div>
                    </div>
                </el-card>
				<span class="recom">热门专利推荐</span>
				<el-card style="margin-bottom: 1.25rem;margin-top: 1.25rem;" v-for="item in twoList">
					<div class="zscqzx-img-1">
						<img src="@/assets/images/fxxfdw/noComplaints.png">
					</div>
					<div>
						<el-row style="margin-bottom: 0.625rem;">
							<span class="zscqzx" style="margin-right: 0.3125rem;" :title="item.patentName">
								{{item.patentName.length >12 ? item.patentName.substring(0,12)+"..." : item.patentName}}
							</span>
							<el-tag type="success">{{dictFormatType(item.patentType)}}</el-tag>
						</el-row>
						<el-row>
							<el-col :span="12" style="color: red;cursor: pointer;">
                                <span class="font-orange" v-if="item.patentPrice==null">询价</span>
                                <span class="font-orange fontsize15" v-else>￥{{item.patentPrice}}</span>
							</el-col>
							<el-col :span="12">
								<el-button type="primary" size="mini" @click="toPage('/main/zscqzhfw/zscqcsDetail/'+item.recid)">了解详情</el-button>
							</el-col>
						</el-row>
					</div>
				</el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import { getMarket,listOrderByDescTwo } from "@/api/zscq/market";
    import { getBrowseCount } from "@/api/basedata/records";
    import {updatePvNum} from "@/api/itempv/pv";

    export default {
        name: "zscqcsDetail",
        data() {
            return {
                // 遮罩层
                loading: true,
                recid:undefined,
                ywViews:{
                    busRecid:undefined,
                    busTableName:'yw_zscq_market',
                },
                detail:{},
                detailTow:{},
                patentStatusOptions:[],
                typeOptions:[],
                fieldOptions:[],
                statusOptions:[],
                fields:[],
                browseCount:0,
                isLoginState:undefined,
				twoList:[]
            }
        },
		watch: {
		　　'$route': function (to, from) {
				/* 解决vue.router 重复点击 跳转同一路由路径，参数改变而不刷新页面的问题，
					以下代码为你在create mounted 中要执行的方法 */
				/* 开始 */
		        this.recid = this.$route.params && this.$route.params.recid;
				this.getMarket();
				
				/* 结束 */
		　　}
		},
        created() {
            this.recid = this.$route.params && this.$route.params.recid;
			
            this.getDicts("INDUSTRYPHY").then(response => {
                this.fieldOptions = response.data;
            });
            this.getDicts("patent_status").then(response => {
                this.patentStatusOptions = response.data;
            });
            this.getDicts("patent_type").then(response => {
                this.typeOptions = response.data;
            });
            /*this.getDicts("market_status").then(response => {
                this.statusOptions = response.data;
            });*/
            this.getMarket();
            updatePvNum("zscq_zscqcs_detail").then(response => {
                //pv 点击知识产权超市详情
            });
        },
        methods: {
            toPage(url){
                this.$router.push({
                    path: url,
                });
                this.$store.commit('SET_MAININDEX', url);
            },
            refresh(){
                this.getMarket();
            },
            getMarket(){
				//----【】需要修改为recid
				let ssessionLoginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
				if (ssessionLoginUser != null && ssessionLoginUser.islogin) {
					this.isLoginState = true;
				} else {
					this.isLoginState = false;
				}
                this.loading = true;
                getMarket(this.recid).then(response => {
                    this.detail=response.data;
                    if(this.detail.patentField!=null && this.detail.patentField!=undefined){
                        this.fields=this.detail.patentField.split(',');
                    }
                    this.getBrowseData();
					this.getListOrderByDescTwo();
                    this.loading = false;
                })
            },
			getListOrderByDescTwo(){
                this.detailTow.patentField =this.detail.patentField;
                    this.detailTow.patentType = this.detail.patentType;
				listOrderByDescTwo(this.detailTow).then(response => {
				    //console.log("response.data",response.rows);
					this.twoList = response.rows;
				})
			},
            getBrowseData(){
                this.ywViews.busRecid= this.recid;
                getBrowseCount(this.ywViews).then(response => {
                    this.browseCount=response;
                })
            },
            dictFormatType(value) {
                return this.selectDictLabel(this.typeOptions, value) || '未知';
            },
            dictFormatField(value) {
                return this.selectDictLabel(this.fieldOptions, value) || '未知';
            },
            dictFormatPatentStatus(value) {
                return this.selectDictLabel(this.patentStatusOptions, value) || '未知';
            },
            dictFormatLabelType(row, column, cellValue) {
                if (cellValue == undefined) {
                    return '-';
                }
                let values = cellValue.split(",");
                let text = '';
                for (let value of values) {
                    text = text + "," + this.selectDictLabel(this.labelTypeOptions, value);
                }
                text = text.substring(1, text.length);
                return text == '' ? '-' : text;
            }
        }
    }
</script>

<style scoped>
    .app-container{
        padding:0px 15px 20px;
    }
    .navigation{
        padding:20px 15px;
        line-height: 20px;
        height: 60px;
        background-color: #F5F5F5;
        margin-bottom: 15px;
    }
    .left-img{
        padding: 0;
        margin: 0;
    }
    .left-img img{
        /*max-height: 260px;*/
        height: 282px;
        width: 180px;
    }
    .detail-title{
        line-height: 40px;
        text-align: left;
        font-weight: bold;
        font-size: 15px;
        padding: 0 15px;
    }
    .detail-row{
        line-height: 30px;
        text-align: left;
        padding: 5px 15px;
    }
    .el-tag{
        margin-right: 15px;
    }
    .el-divider--horizontal{
        margin: 5px 0px;
    }
    .detail-row2{
        height: 60px;
        line-height: 30px;
        text-align: left;
        padding: 15px 15px;
        background-color: #f2f2f2;
        margin-top: 15px;
    }
    .tips{
        line-height: 50px;
        text-align: left;
        /*padding-left: 50px;*/
    }
    .tips-2{
        font-size: 12px;
        color: #999999;
    }
    .box-card{
        margin-top: 20px;
        text-align: left;
    }
    /deep/.el-card__header{
        background-color: #f2f2f2;
        font-weight: bold;
        padding: 0 20px;
    }
    .el-card{
        border: 0px;
    }
    .card-header{
        display: flex;
    }
    .card-header-left{
        height:30px;
        padding:12px 0;
    }
    .card-header-left img{
        height: 30px;
    }
    .card-header-right{
        padding: 18px 0 18px 10px;
        flex: 1;
    }
    .page-right{
        padding-left: 15px;
    }
    .zscqzx{
        line-height: 30px;
        font-size: 15px;
        font-weight: bold;
    }
    .fontsize15{
        font-size: 18px;
    }
    .font-orange{
        color: #FFA500;
    }
    .zscqzx-img{
        padding-right: 10px;
    }
    .zscqzx-img img{
        height: 60px;
    }
	.recom{
		font-size: 1rem;
		font-weight: bold;
	}
	.zscqzx-img-1{
		padding-right: 10px;
	}
	.zscqzx-img-1 img{
	    height: 13rem;
	}
</style>